import { QUESTION_TYPE } from '../../../../constants/questionTypes';
import type { CsatQuestion } from '../../../../types/index';
import type { ApiQuestion } from '../../../../internalTypes';
import type { ResolvedQuestionShell } from '../shared/resolveQuestionShell';
import { detectDisplayStyle } from '../shared/detectDisplayStyle';
import { detectMatrixFormat } from '../shared/detectMatrixFormat';
import { buildScaleColumns } from '../matrix/buildScaleColumns';
import { buildSimpleStatementRows } from '../matrix/buildSimpleStatementRows';
import { resolveMatrixScaleOptions } from '../matrix/resolveMatrixScaleOptions';

export function mapCsatQuestion(
  raw: ApiQuestion,
  shell: ResolvedQuestionShell,
  language?: string
): CsatQuestion {
  const configs = raw.questionConfigs ?? [];
  const { scaleColumns, scaleAnchorLabels, hasNotApplicableOption, reverseScaleOrder } =
    resolveMatrixScaleOptions(raw, configs, language, buildScaleColumns(raw, language));

  return {
    ...shell,
    type: QUESTION_TYPE.CSAT_MATRIX,
    statementRows: buildSimpleStatementRows(raw, language),
    scaleColumns,
    displayStyle: detectDisplayStyle(configs, raw.dataSubType),
    hasNotApplicableOption,
    reverseScaleOrder,
    gridLayout: detectMatrixFormat(configs),
    ...(scaleAnchorLabels.length > 0 ? { scaleAnchorLabels } : {}),
  };
}
